import queryString from "query-string";
import useGet from "hooks/useGet";

import { PageLoader } from "components";

const ProductImageRedirect = ({ history, location }) => {
  const { sku } = queryString.parse(location.search);

  useGet({
    query: ["sku", sku],
    path: `/products/search`,
    search: {
      sku,
    },
    onSuccess: ({ data: { product_id, product_group_id } }) => {
      history.push(
        `/products_manage/product_groups/${product_group_id}/images/products/${product_id}`
      );
    },
    onError: () => {
      history.push("/products");
    },
  });

  return <PageLoader />;
};

export default ProductImageRedirect;
